export default "__VITE_ASSET__CEvN71pg__"